import VariablesImg from '../../Images/VariablesImg.jpg'

export default function Variables(props) {
    return (
        <div style={{marginTop: '10px', marginLeft:'0px', border: '3px', padding:'40px', borderStyle:'solid', borderColor:'grey'}}>
               {/* <SectionTitle title={props.topicId}/> */}
               <h1>Variables</h1>
               <p>
                                
           
                        
                        <h2>Intro to Variables;</h2>
A variable is a way to store information and values. To bring a variable into your code, it must be declared, usually by a keyword such as var and then assign it a value in most cases. Some programming languages allow you to declare a variable and only later assign it a value.
<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={VariablesImg} alt="Variables" width="65%"/>
                                </div>
                
                        </p>
            </div>
    )
}